<div class="w-100 d-flex price-container">
  <div class="price-unit-title">
    <span class="unit-name">{{ data?.title }}</span
    >&nbsp;
    <span class="price-unit-type">
      {{
        data?.type === 'Gold' ? 'مبتنی بر طلا' : data?.type === 'FixedIncome' ? 'درامد ثابت' : data?.type === 'Index' ? 'شاخصی' : 'سهامی'
      }}</span
    >
  </div>
  <div class="price-detail">
    <div class="price-cost">
      <span class="price-cost-text">{{ sectionType === 'BUY' ? 'قیمت خرید هر واحد' : 'قیمت فروش هر واحد' }}</span>
      <span class="price-cost-value is-currency">
        {{ (sectionType === 'BUY' ? data?.purchaseNav : data?.saleNav) | number }}
        ریال
      </span>
    </div>
    @if (sectionType === 'SELL') {
      <div class="price-amount">
        <span class="price-amount-text">
          موجودی قابل برداشت شما

          <img
            src="wealth-assets/icons/question.svg"
            alt="موجودی قابل برداشت شما"
            ngxTooltip="این موجودی ممکن است به دلیل در انتظار بودن تعدادی از واحد‌ها برای فروش، با موجودی کلی شما متفاوت باشد."
            [tooltipPosition]="'bottom'"
          />
        </span>
        <span class="price-amount-value"> {{ unitCount }} واحد </span>
      </div>
    }
  </div>
</div>
